import { Turbo } from '@hotwired/turbo-rails'
import { createConsumer } from '@rails/actioncable'

let consumer
let subscription

function enabled () {
  return document.querySelector('[data-remote-debugging-admin-channel]') !== null
}

function startSubscription () {
  if (subscription || !enabled()) return

  consumer = createConsumer()
  subscription = consumer.subscriptions.create('RemoteDebuggingAdminChannel', {
    received (message) {
      Turbo.renderStreamMessage(message)
    }
  })
}

function stopSubscription () {
  subscription?.unsubscribe()
  subscription = null
  consumer?.disconnect()
  consumer = null
}

function syncSubscription () {
  if (enabled()) {
    startSubscription()
  } else {
    stopSubscription()
  }
}

document.addEventListener('turbo:load', syncSubscription)
syncSubscription()
